module.exports = ".content {\n    margin-top: 20px;\n    margin-right: 20px;\n    margin-left: 20px;\n}"